/* eslint-disable no-useless-escape */

const isEmailValid = (email) => {
  const reg = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return reg.test(email);
};

const urls = {
  request: 'request_reset_pwd/',
  check: 'check_reset_pwd_token/',
  reset: 'reset_pwd/',
  invitations: 'invitations/',
};

const getConfig = ({ hasToken, isTokenValid, error, success }) => {
  if (error)
    return {
      title: 'credential_error_title',
      text: 'credential_error_text',
      help: 'credential_error_help',
    };
  if (success)
    return {
      title: 'credential_success_title',
      text: 'credential_success_text',
      help: 'credential_success_help',
    };
  if (!hasToken)
    return { title: false, text: 'credential_text', btn: 'credential_submit' };
  if (!isTokenValid)
    return {
      title: 'password_token_expired_title',
      text: 'credential_text',
      btn: 'credential_submit',
    };
  if (isTokenValid)
    return {
      title: 'password_title',
      text: 'password_text',
      btn: 'password_submit',
    };
};

export { isEmailValid, urls, getConfig };
export default undefined;
